import React, { Component } from "react";
import { injectIntl } from "react-intl";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { Form, Input, Button, Row } from "antd";
import moment from "moment";
import {
  setEditAsset,
  unsetSelectEditAsset,
  MoveSelectedAsset
} from "../../actions/ClientAction";
import { sendNotification, getNewPermission } from "../../utils/index";
import { setkeyboardEnabled } from "../../actions/AppAction";

export class RenameAsset extends Component {
  // TODO: Cristhian debe corregir todo esto
  // REHACER COMPONENTE, EN CASO DE SER NECESARIO SEPARAR EN OTRO COMPONENTE

  constructor(props) {
    super(props);

    this.state = {
      oldName: null,
      _id: "",
      editName: "",
      tags: [],
      copyright: {
        createDate: moment().format("YYYY-MM-DD"),
        dueDate: moment().format("YYYY-MM-DD")
      },
      start: false,
      destroy: false,
      folderId: null,
      canMove: true,
      canEdit: true
    };
  }

  componentDidMount() {
    const { itemEditSelected, folderselect, user, newMatrix } = this.props;

    if (user.role === "operator" && user.clientRole === "operator") {
      this.setState({
        canMove: getNewPermission(itemEditSelected._id, newMatrix, "move"), //matrix.find(r => r.action === 'move').enabled,
        canEdit: getNewPermission(itemEditSelected._id, newMatrix, "edit") //matrix.find(r => r.action === 'edit').enabled
      });
    }

    if (itemEditSelected) {
      this.setState({
        oldName: itemEditSelected.name,
        _id: itemEditSelected._id,
        tags: itemEditSelected.metadata.descriptiveTags,
        copyright: {
          createDate: itemEditSelected.metadata.createDate,
          dueDate: itemEditSelected.metadata.dueDate
        }
      });
    }

    if (folderselect && folderselect !== "") {
      this.setState({
        folderId: folderselect
      });
    }
    this.props.setkeyboardEnabled(true);
  }

  componentDidUpdate(prevProps) {
    const {
      isUpdating,
      error,
      intl,
      keyCollection,
      itemEditSelected
    } = this.props;
    const { start } = this.state;

    if (prevProps.itemEditSelected !== itemEditSelected) {
      this.setState({
        oldName: itemEditSelected.name,
        _id: itemEditSelected._id,
        tags: itemEditSelected.metadata.descriptiveTags,
        copyright: {
          createDate: itemEditSelected.metadata.createDate,
          dueDate: itemEditSelected.metadata.dueDate
        }
      });
    }
    //ACTUALIZAR ASSET EN EDITAR
    if (
      !isUpdating &&
      error &&
      prevProps.error !== error &&
      keyCollection !== "assetsConfirm"
    ) {
      sendNotification(
        "error",
        intl,
        intl.formatMessage({ id: "error_message" })
      );

      this.setState({
        start: false
      });
    } else if (!isUpdating && start && keyCollection !== "assetsConfirm") {
      sendNotification(
        "success",
        intl,
        intl.formatMessage({ id: "notification_asset_edited_success" })
      );
      this.setState({
        start: false
      });
      this.props.unsetSelectEditAsset(keyCollection);
    }

    // CONFIRMAR ASSET EN CONFIRMAR ASSETS
    if (
      !isUpdating &&
      error &&
      prevProps.error !== error &&
      keyCollection === "assetsConfirm"
    ) {
      sendNotification(
        "error",
        intl,
        intl.formatMessage({ id: "error_message" })
      );

      this.setState({
        start: false
      });
    } else if (!isUpdating && start && keyCollection === "assetsConfirm") {
      sendNotification(
        "success",
        intl,
        intl.formatMessage({ id: "asset_confirmed" })
      );
      this.setState({
        oldName: "",
        editName: "",
        _id: "",
        tags: "",
        copyright: {
          createDate: "",
          dueDate: ""
        },
        start: false,
        destroy: true
      });
    }
  }

  handleTags = objectTag => {
    this.setState({ tags: objectTag.tags });
  };

  handleCopyright = copyright => {
    this.setState({ copyright: copyright.copyright });
  };

  handleOnInputChange = e => {
    this.setState({
      editName: e.target.value
    });
  };

  handleEditAsset = key => {
    const {
      keyCollection,
      workclient,
      intl,
      folderselect,
      page,
      limit,
      itemEditSelected,
      newMatrix,
      user
    } = this.props;
    const { _id, editName, folderId } = this.state;
    // tags, copyright,
    switch (key) {
      case "edit":
        if (editName.length === 0) {
          sendNotification(
            "error",
            intl,
            intl.formatMessage({ id: "asset_name_empty" })
          );
          return;
        }

        const asset = {
          _id,
          name: editName,
          metadata: {
            descriptiveTags: itemEditSelected.metadata.descriptiveTags,
            createDate: itemEditSelected.metadata.createdDate,
            dueDate: itemEditSelected.metadata.dueDate
          }
        };
        this.setState(
          {
            start: true
          },
          () => this.props.setEditAsset(keyCollection, workclient, asset)
        );
        this.props.setkeyboardEnabled(false);
        break;

      case "move":
        if (folderId) {
          const canMoveToFolder =
            user.clientRole !== "admin"
              ? getNewPermission(folderId, newMatrix, "move")
              : true;
          if (canMoveToFolder) {
            this.props.MoveSelectedAsset(
              keyCollection,
              workclient,
              itemEditSelected,
              folderId,
              folderselect,
              page,
              intl,
              limit
            );
            this.props.setkeyboardEnabled(false);
          } else {
            sendNotification(
              "warning",
              intl,
              intl.formatMessage({ id: "permission_denied" })
            );
          }
        } else
          sendNotification(
            "warning",
            intl,
            intl.formatMessage({ id: "select_valid_destination" })
          );
        break;

      default:
        break;
    }
  };

  handleFolderSelect = folderId => {
    this.setState({
      folderId
    });
  };

  handleCloseDrawer = () => {
    const { keyCollection } = this.props;
    this.props.setkeyboardEnabled(false);
    this.props.unsetSelectEditAsset(keyCollection);
  };

  render() {
    const {
      itemEditSelected,
      isUpdating,
      keyCollection,
      intl
    } = this.props;
    const { oldName, editName, destroy, canEdit } = this.state;
    const isBunker =
      itemEditSelected.type === "folder" || itemEditSelected.type === "bunker";
    const prefix = isBunker ? "" : "_file";
    return (
      <React.Fragment>
        {keyCollection === "assetsConfirm" ? (
          <span>{intl.formatMessage({ id: "confirm_assets" })}</span>
        ) : (
          <div>
            {canEdit && (
              <Form layout="vertical">
                {itemEditSelected && !destroy && (
                  <React.Fragment>
                    <Form.Item style={{ marginBottom: "10px" }}>
                      <p className="rename-modal-label">
                        {intl.formatMessage({
                          id: `rename-modal-label1${prefix}`
                        })}
                        :
                      </p>

                      <Input
                        placeholder={intl.formatMessage({
                          id: `rename-modal-input1${prefix}`
                        })}
                        value={oldName}
                        className="rename-modal-input rename-folder"
                        contentEditable={false}
                        disabled
                      />
                      <p className="rename-modal-label">
                        {intl.formatMessage({
                          id: `rename-modal-label2${prefix}`
                        })}
                        :{" "}
                      </p>

                      <Input
                        placeholder={intl.formatMessage({
                          id: `rename-modal-input2${prefix}`
                        })}
                        value={editName}
                        onChange={this.handleOnInputChange}
                        className="rename-modal-input rename-folder"
                      />
                    </Form.Item>
                    <Form.Item>
                      <Row type={"flex"} justify={"space-between"}>
                        <Button
                          loading={isUpdating}
                          size={"large"}
                          type={"primary"}
                          className="rename-modal-button accept"
                          onClick={() => this.handleEditAsset("edit")}
                        >
                          {intl.formatMessage({ id: "edit_asset" })}
                        </Button>
                        <Button
                          size={"large"}
                          type={"primary"}
                          ghost
                          className="rename-modal-button cancel"
                          onClick={this.handleCloseDrawer}
                        >
                          {intl.formatMessage({ id: "cancel_button" })}
                        </Button>
                      </Row>
                    </Form.Item>
                  </React.Fragment>
                )}
              </Form>
            )}
          </div>
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { keyCollection, assetKey } = ownProps;
  let object;

  switch (keyCollection) {
    case "assetsRoot":
      object = {
        isUpdating: state.assetsRoot.isUpdating,
        itemEditSelected: state.assetsRoot.data.find(r => r.isEditSelected),
        error: state.assetsRoot.error
      };
      break;
    case "assetsLastUploads":
      object = {
        isUpdating: state.assetsLastUploads.isUpdating,
        itemEditSelected: state.assetsLastUploads.data.find(
          r => r.isEditSelected
        ),
        isMoving: state.assetsLastUploads.isMoving,
        error: state.assetsLastUploads.error
      };
      break;
    case "assetsShared":
      object = {
        isUpdating: state.assetsShared.isUpdating,
        itemEditSelected: state.assetsShared.data.find(r => r.isEditSelected),
        isMoving: state.assetsShared.isMoving,
        error: state.assetsShared.error
      };
      break;
    case "assetsFavorites":
      object = {
        isUpdating: state.assetsFavorites.isUpdating,
        itemEditSelected: state.assetsFavorites.data.find(
          r => r.isEditSelected
        ),
        isMoving: state.assetsFavorites.isMoving,
        error: state.assetsFavorites.error
      };
      break;
    case "assetsExplore":
      object = {
        isUpdating: state.assetsExplore.isUpdating,
        itemEditSelected: state.assetsExplore.data.find(r => r.isEditSelected),
        folderselect: state.assetsExplore.folderselect,
        isMoving: state.assetsExplore.isMoving,
        page: state.assetsExplore.page,
        limit: state.assetsExplore.limit,
        error: state.assetsExplore.error
      };
      break;
    case "assetsConfirm":
      object = {
        isUpdating: state.assetsConfirm.isUpdating,
        itemEditSelected: state.assetsConfirm.data.find(
          r => r._id === assetKey
        ),
        error: state.assetsConfirm.error
      };
      break;
    case "searcher":
      object = {
        isUpdating: state.searcher.isUpdating,
        itemEditSelected: state.searcher.data.find(r => r.isEditSelected),
        isMoving: state.searcher.isMoving,
        error: state.searcher.error
      };
      break;

    default:
      object = {};
      break;
  }
  return {
    ...object,
    newColor:
      state.authUser.user && state.authUser.user.color
        ? state.authUser.user.color
        : "#2E97CF",
    verticalCount: state.app.verticalCount,
    horizontalCount: state.app.horizontalCount,
    workclient: state.client.workclient,
    user: state.authUser.user,
    matrix: state.group.matrix,
    newMatrix: state.group.newMatrix
  };
};

const mapDispatchToProps = {
  setEditAsset,
  unsetSelectEditAsset,
  setkeyboardEnabled,
  MoveSelectedAsset
};

export default injectIntl(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(RenameAsset))
);
